<template>
  <div class="block" id="experience">
    <ArticleTitle :rotateds="true" :shovsnakes="true" :articleid="'experience_n'" :articletitle="'Work Experience'"
                  id="experience_n"/>
    <div class="colomn" id="experience_content">
      <div class="wraper" v-for="expdata in raw.experience_set" :key="expdata.name">
        <ContentBlock :datac="expdata" :hardskill="false"/>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import ContentBlock from "@/components/ContentBlock";
import ArticleTitle from "@/components/ArticleTitle";

export default {
  name: "ExperiencePreviusWorks",
  components: {
    ArticleTitle,
    ContentBlock,

  },
  mounted() {
    // this.$store.dispatch('GetData')
  },
  computed: mapState(["raw",]),
}
</script>

<style scoped>
#experience .colomn {
  flex-direction: column;
  margin: 6vw 0 0 120px;
}


@media screen and (max-width: 1024px) {
  #experience .colomn {
    margin: 30px 10px 50px 10px;
  }
}
</style>